import React from "react";
import { BootstrapTable } from "react-bootstrap-table";
import Common from "../constants/common";

export default class CustomTable extends React.Component {
    constructor() {
        super();
        this.state = {
            tablePosition: 0
        };
    }

    componentDidMount() {
        let position = Common._calculatePosition(document.getElementById("bootstrapTable"));
        this.setState({
            tablePosition: position["y"]
        });
    }

    render() {
        return (
            <div id="bootstrapTable" className="checkbox-table">
                <BootstrapTable
                    bodyStyle={{
                        minHeight: `calc(100vh - 47px - ${this.state.tablePosition}px`,
                        maxHeight: `calc(100vh - 47px - ${this.state.tablePosition}px`
                    }}
                    {...this.props}
                ></BootstrapTable>
            </div>
        );
    }
}
